// Полоса «Заказы обновляются с задержкой» по потере сокета. По умолчанию выключена:
// сокет рвётся на короткие рестарты сервера и смену сети, а данные при этом всё равно
// догоняет сторож. Включать переменной VUE_APP_SOCKET_LOST_BAR=true (владелец, 2026-10-22).
// Полосы «Нет подключения к интернету» и «Сервер недоступен» от неё не зависят
export const SOCKET_LOST_BAR_ENABLED = process.env.VUE_APP_SOCKET_LOST_BAR === 'true'
